import React from 'react'
import clsx from 'clsx'
import { useGetGroupEvent } from '../api-hooks'
import BookingAttachmentCard from './booking-attachment-card'
import { formatGroupEventSessionLine } from './format-booking-attachment'

const UnableToRenderCard = ({ type }) => (
  <div
    className={clsx('str-chat__message-attachment-card', {
      [`str-chat__message-attachment-card--${type}`]: type,
    })}
  >
    <div className="str-chat__message-attachment-card--content">
      <div className="str-chat__message-attachment-card--text">
        this content could not be displayed
      </div>
    </div>
  </div>
)

const GroupEventAttachmentCard = ({
  group_event_id: id,
  pga_booking_url: pgaBookingURL,
  booking_url: bookingUrl,
  type,
}) => {
  const resolvedBookingURL = pgaBookingURL || bookingUrl
  const { data, loading, error } = useGetGroupEvent({ id, skip: !id })
  const groupEvent = data?.groupEvents?.[0]

  if (!id) {
    return <UnableToRenderCard type={type} />
  }

  if (loading) {
    return null
  }

  if (!resolvedBookingURL || error || !groupEvent) {
    return <UnableToRenderCard type={type} />
  }

  return (
    <BookingAttachmentCard
      bookingUrl={resolvedBookingURL}
      detailLine={formatGroupEventSessionLine(groupEvent.sessions)}
      imageUrl={groupEvent.featuredImageUrl}
      locationName={groupEvent.coachFacility?.name}
      title={groupEvent.title}
      type={type}
    />
  )
}

export default React.memo(GroupEventAttachmentCard)
